module.exports = __webpack_public_path__ + "static/img/active4.6473a009.png";